import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChildNameComponent } from './child-name/child-name.component';
import { ChildNameTestingComponent } from './child-name/child-name-testing/child-name-testing.component';
import { ReactiveFormsModule } from '@angular/forms';
import { FormModule } from '@ui/form/form.module';
import { NumberPickerModule } from '@ui/change-number/change-number.module';
import { CheckboxModule } from '@ui/form/checkbox/checkbox.module';
import { MatSelectModule } from '@angular/material/select';
import { GetRightElementValuePipe } from './child-name/get-right-element-value.pipe';
import { ColorPickerDirective } from 'ngx-color-picker';
import { ButtonModule } from '@ui/button/button/button.module';
import {
  MatMenuModule,
} from '@angular/material/menu';
import { BoxShadowEditorModule } from '@ui/box-shadow-editor/box-shadow-editor.module';
import { NgxMoveableModule } from 'ngx-moveable';
import { TabloStudioComponent } from './tablo-studio/tablo-studio.component';
import { TabloCanvaComponent } from './tablo-studio/tablo-canva/tablo-canva.component';
import { ZonelessMoveableComponent } from './tablo-studio/tablo-canva/zoneless-moveable.component';
import { TabloMembersGroupComponent } from './tablo-studio/tablo-members-group/tablo-members-group.component';
import { MatIconModule } from '@angular/material/icon';
import { LanguageModule } from 'ZalamoLibrary/src/lib/zalamo/language/language.module';
import { TabloFacesPipe } from './tablo-studio/tablo-faces.pipe';
import { ImageLoaderModule } from 'ZalamoLibrary/src/lib/core/image/image-loader/image-loader.module';
import { ControlsDisplayPipe } from './tablo-studio/tablo-canva/controls-display.pipe';
import { TabloSinglePhotoEditorComponent } from './tablo-studio/tablo-single-photo-editor/tablo-single-photo-editor.component';
import { VirtualScrollModule } from '@ui/virtual-scroll/virtual-scroll.module';
import { PinchZoomModule } from '@ui/ivypinch_pro/pinch-zoom.module';
import { WallDecorFrontModule } from '@ui/look-book-front/wall-decor-front/wall-decor-front.module';
import { SinglePhotoCropperComponent } from './tablo-studio/tablo-single-photo-editor/single-photo-cropper/single-photo-cropper.component';
import { SideDialogModule } from '@ui/side-dialog';
import { TabloTextEditorComponent } from './tablo-studio/tablo-text-editor/tablo-text-editor.component';
import { MatSliderModule } from '@angular/material/slider';
import { ImagesModule } from '@ui/images/images.module';
import { FitIntoContainerDirective } from './tablo-studio/fit-into-container.directive';
import { FontsManagerModule } from '@ui/fonts-manager/fonts-manager.module';
import { TabloOtherElementsForSnapPipe } from './tablo-studio/tablo-canva/tablo-other-elements-for-snap.pipe';
import { VerticalGuidesForTabloPipe } from './tablo-studio/tablo-canva/vertical-guides-for-tablo.pipe';
import { HorizontalGuidesForTabloPipe } from './tablo-studio/tablo-canva/horizontal-guides-for-tablo.pipe';
import { TabloBoundAreaPipe } from './tablo-studio/tablo-canva/tablo-bound-area.pipe';
import { LookBookFrontModule } from '@ui/look-book-front/look-book-front.module';
import { SingleFileUploaderModule } from 'ZalamoLibrary/src/lib/upload/components/single-file-uploader/single-file-uploader.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AddYearDetailsPipe } from './tablo-studio/tablo-canva/add-year-details.pipe';
import { PrintCanvaComponent } from './print-canva/print-canva.component';
import { MatInputModule } from '@angular/material/input';
import { UnRetouchedFilesPipe } from './tablo-studio/tablo-members-group/un-retouched-files.pipe';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { TabloStaticTextEditorComponent } from './tablo-studio/tablo-static-text-editor/tablo-static-text-editor.component';
import { ParseStaticTextPipe } from './tablo-studio/tablo-canva/parse-static-text.pipe';
import { StaticTextHorizontalAligmentPipe } from './tablo-studio/tablo-canva/static-text-horizontal-aligment.pipe';
import { FilterEventsForElementPipe } from './tablo-studio/tablo-canva/filter-events-for-element.pipe';
import { FaceToLabelPhotographerComponent } from './tablo-studio/tablo-members-group/face-to-label-photographer/face-to-label-photographer.component';
import { CoverModule } from '@ui/cover/cover.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ZalamoDialogModule } from '@ui/zalamo-dialog/zalamo-dialog.module';
import { CoverDisplayStandaloneModule } from '@ui/cover/cover/cover-display-standalone/cover-display-standalone.module';
import { IsTabloMemberPickCompletedPipe } from './tablo-studio/tablo-members-group/face-to-label-photographer/is-tablo-member-pick-completed.pipe';
import { IsPhotoTakenPipe } from './tablo-studio/tablo-members-group/face-to-label-photographer/is-photo-taken.pipe';
import { MemberNameForPickedPhotoPipe } from './tablo-studio/tablo-members-group/face-to-label-photographer/member-name-for-picked-photo.pipe';
import { TabloSmartCropModuleModule } from '@ui/tablo-generator/tablo-studio/tablo-smart-crop/tablo-smart-crop-module/tablo-smart-crop-module.module';
import { MatExpansionModule } from '@angular/material/expansion';
import { DetectOverflowDirective } from './tablo-studio/tablo-canva/directives/detect-overflow.directive';
import { NegativeBootomMarginPipe } from './tablo-studio/tablo-canva/pipes/negative-bootom-margin.pipe';
import { SinglePhotoFaceMatchComponent } from './tablo-studio/single-photo-face-match/single-photo-face-match.component';
import { TabloNewLayersEditorComponent } from './tablo-studio/tablo-layers-editor/tablo-new-layers-editor.component';
import { GetConfigFromMainOrFromChildPipe } from './tablo-studio/tablo-members-group/get-config-from-main-or-from-child.pipe';
import { GenerateSingleChildTransformPipe } from './tablo-studio/tablo-members-group/generate-single-child-transform.pipe';
import { CalculateBackgroundForChildPipe } from './tablo-studio/tablo-members-group/pipes/calculate-background-for-child.pipe';
import { TabloFixSchoolLogoComponent } from './tablo-studio/tablo-canva/tablo-fix-school-logo/tablo-fix-school-logo.component';
import { StaticTextLabelPipe } from './tablo-studio/pipes/static-text-label.pipe';
import { NameTransformPipe } from './tablo-studio/tablo-members-group/pipes/name-transform.pipe';
import { StaticPhotoConfigEditorComponent } from './tablo-studio/static-photo-config-editor/static-photo-config-editor.component';
import { ImageListPickerModule } from '@ui/form/image-list-picker/image-list-picker.module';
import { LeftPaddingPipe } from './tablo-studio/tablo-members-group/pipes/left-padding.pipe';
import { PaddingRightPipe } from './tablo-studio/tablo-members-group/pipes/padding-right.pipe';
import { StaticGraphicConfigComponent } from './tablo-studio/static-graphic-config/static-graphic-config.component';
import { UppercaseTextPipe } from './tablo-studio/tablo-canva/uppercase-text.pipe';
import { ProgressBarComponent } from './tablo-studio/tablo-members-group/face-to-label-photographer/progress-bar.component';
import { CustomGraphicStylesPipe } from './tablo-studio/tablo-canva/pipes/custom-graphic-styles.pipe';
import { CustomGraphicsParentCssPipe } from './tablo-studio/tablo-canva/pipes/custom-graphics-parent-css.pipe';
import { PhotoOverlayStylesPipe } from './tablo-studio/tablo-members-group/pipes/photo-overlay-styles.pipe';
import { PhotoOverlayImagePipe } from './tablo-studio/tablo-members-group/pipes/photo-overlay-image.pipe';
import { GroupMemberPhotoRenderConfigPipe } from './tablo-studio/tablo-members-group/pipes/group-member-photo-render-config.pipe';
import { PhotoOverlayColorDirective } from './tablo-studio/tablo-members-group/directives/photo-overlay-color.directive';
import { PhotoOverlayConfigComponent } from './tablo-studio/photo-overlay-config/photo-overlay-config.component';
import { SvgPathScaledPipe } from './tablo-studio/tablo-canva/pipes/svg-path-scaled.pipe';
import { ResolveTabloTextPipe } from './tablo-studio/tablo-canva/resolve-tablo-text.pipe';
import { TabloFaceCropperComponent } from './tablo-studio/single-photo-face-match/tablo-face-cropper.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { TabloSidebarShellComponent } from './tablo-studio/sidebar/tablo-sidebar-shell.component';

@NgModule({
  declarations: [
    ChildNameComponent,
    ChildNameTestingComponent,
    GetRightElementValuePipe,
    TabloStudioComponent,
    TabloCanvaComponent,
    ZonelessMoveableComponent,
    TabloMembersGroupComponent,
    TabloFacesPipe,
    ControlsDisplayPipe,
    TabloSinglePhotoEditorComponent,
    SinglePhotoCropperComponent,
    TabloTextEditorComponent,
    FitIntoContainerDirective,
    TabloOtherElementsForSnapPipe,
    VerticalGuidesForTabloPipe,
    HorizontalGuidesForTabloPipe,
    TabloBoundAreaPipe,
    AddYearDetailsPipe,
    PrintCanvaComponent,
    UnRetouchedFilesPipe,
    TabloStaticTextEditorComponent,
    ParseStaticTextPipe,
    StaticTextHorizontalAligmentPipe,
    FilterEventsForElementPipe,
    UppercaseTextPipe,
    FaceToLabelPhotographerComponent,
    IsTabloMemberPickCompletedPipe,
    IsPhotoTakenPipe,
    MemberNameForPickedPhotoPipe,
    DetectOverflowDirective,
    NegativeBootomMarginPipe,
    ResolveTabloTextPipe,
    SinglePhotoFaceMatchComponent,
    TabloNewLayersEditorComponent,
    GetConfigFromMainOrFromChildPipe,
    GenerateSingleChildTransformPipe,
    CalculateBackgroundForChildPipe,
    TabloFixSchoolLogoComponent,
    StaticTextLabelPipe,
    NameTransformPipe,
    StaticPhotoConfigEditorComponent,
    LeftPaddingPipe,
    PaddingRightPipe,
    StaticGraphicConfigComponent,
    ProgressBarComponent,
    CustomGraphicStylesPipe,
    CustomGraphicsParentCssPipe,
    PhotoOverlayStylesPipe,
    PhotoOverlayImagePipe,
    GroupMemberPhotoRenderConfigPipe,
    PhotoOverlayConfigComponent,
    PhotoOverlayColorDirective,
    SvgPathScaledPipe,
    TabloFaceCropperComponent,
    TabloSidebarShellComponent,
  ],
  exports: [
    ChildNameTestingComponent,
    TabloStudioComponent,
    TabloFacesPipe,
    PrintCanvaComponent,
    ProgressBarComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormModule,
    NumberPickerModule,
    CheckboxModule,
    MatSelectModule,
    ColorPickerDirective,
    ButtonModule,
    MatMenuModule,
    BoxShadowEditorModule,
    NgxMoveableModule,
    MatIconModule,
    LanguageModule,
    ImageLoaderModule,
    VirtualScrollModule,
    PinchZoomModule,
    WallDecorFrontModule,
    SideDialogModule,
    MatSliderModule,
    ImagesModule,
    FontsManagerModule,
    LookBookFrontModule,
    SingleFileUploaderModule,
    MatProgressSpinnerModule,
    MatInputModule,
    MatTooltipModule,
    MatButtonModule,
    CoverModule,
    DragDropModule,
    ZalamoDialogModule,
    CoverDisplayStandaloneModule,
    TabloSmartCropModuleModule,
    MatExpansionModule,
    ImageListPickerModule,
    MatSidenavModule,
  ],
})
export class TabloGeneratorModule {}
